import React, { PureComponent } from 'react';

class TabPanel extends PureComponent {
  render() {
    const { children } = this.props;
    return <div>{children}</div>;
  }
}

export default TabPanel;
